export enum CustomerPriceType {
  CONTRACTED = 'CONTRACTED',
  CUSTOM = 'CUSTOM'
}
